// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__1NbRW","kitchen":"styles_kitchen__2Jtkb","mountains":"styles_mountains__10ASp","road":"styles_road__1K3-M"};